import { Params } from "@angular/router";
import { isValid } from "date-fns/esm";
import { getTimeRangeByKey, TIME_RANGE_CUSTOM_NAME, TRange } from "./time-range-constants";

export function buildRangeQueryParams(range: TRange | null | undefined): Params {
	return {
		start: range?.from?.toISOString?.(),
		end: range?.to?.toISOString?.(),
		rt: range?.name || TIME_RANGE_CUSTOM_NAME,
	};
}

export function rangeQueryParamsEqual(current: Params | null | undefined, next: Params | null | undefined): boolean {
	return (
		current?.start === next?.start &&
		current?.end === next?.end &&
		(current?.rt || TIME_RANGE_CUSTOM_NAME) === (next?.rt || TIME_RANGE_CUSTOM_NAME)
	);
}

/** Parse start/end/rt query params into a TRange, or null if invalid. */
export function parseRangeFromQuery(queryParams: Params | null | undefined): TRange | null {
	if (!queryParams?.start || !queryParams?.end) return null;
	const queryStart = new Date(queryParams.start);
	const queryEnd = new Date(queryParams.end);
	if (!isValid(queryStart) || !isValid(queryEnd)) return null;
	const rangePreset = getTimeRangeByKey(queryParams.rt);
	const updatedRange = (
		rangePreset
			? {
					...rangePreset,
					rangeType: rangePreset.rangeType ?? null,
					name: queryParams.rt || rangePreset.name || TIME_RANGE_CUSTOM_NAME,
					from: queryStart,
					to: queryEnd,
				}
			: {
					rangeType: null,
					name: queryParams.rt || TIME_RANGE_CUSTOM_NAME,
					from: queryStart,
					to: queryEnd,
				}
	) as TRange;
	if (rangePreset?.afterParse) rangePreset.afterParse(updatedRange);
	return updatedRange;
}
